<div class="container" >

     <div class="shadow p-3 mb-2 bg-white rounded">
       <div class="row">
        <div class="p-4 mb-2 bg-primary text-white width: 8rem"><h1 class=" text-white text-center" >Certificado Honorarios DCyF</h1></div>
 
        <div class="card-column" style="width: 8rem;border:0ch" ></div>
        <div class="card-column" style="width: 58rem;border:0ch" > 
        </div>
      </div>
        <div class="row">
          <div class="col-4"></div>
          <div class="col-4"><img class="card-img-top" src="assets/img/inicio.jpg" alt="portada"></div>
          <div class="col-4"></div>
        </div>
  
<div class="row">
  <div class="card-column" style="width: 8rem;border:0ch">
    <div class="card-body"></div>
  </div>
   <h5 class="text-center text-primary"> 
    Puede acceder utilizando tu acceso Active Directory</h5>
  <div class="card-column" style="width: 22rem;border:0ch" >   <div class="card-body"></div></div>
  <div class="card-column" > 
    <div class="d-grid gap-2">
      <form class="row g-3" [formGroup]="form" (ngSubmit)="loginAccion()">
        <div class="mb-3">
          <label for="user" class="form-label">Usuario</label>
          <input type="text" formControlName="user" class="form-control" id="user" aria-describedby="user">
        </div>
        <div class="mb-3">
          <label for="pass" class="form-label">Contraseña</label>
          <input type="password" formControlName="pass" class="form-control" id="pass">
        </div>
        <!-- Código para visualizar botón oficial iniciar sesión con ClaveÚnica-->
        <button class="btn btn-outline-dark" type="submit"><fa-icon [icon]="['fas', 'sign-in-alt']"></fa-icon> Iniciar Sesión</button>
        <!--./ fin botón-->
      </form>
    </div>
</div> <!-- fin cardcolumn-->
</div>
</div> <!-- Termina div shadow -->
</div> <!-- Termina div container-->
<script>
  
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'UA-10529528-23');
  gtag('event', 'Inicio de la solicitud', {
      'event_category': 'Trámite digital',
      'event_label': 'Trámite - 1000830000',
      'value': '0'   });
      
  
</script>

 